import React, { useCallback } from 'react';
import { getInProductFeedbackLocalizedSettings } from './getInProductFeedbackLocalizedSettings';
import { getInProductFeedbackMyAccountFeedbackItemSettings } from './InProductFeedbackData';
import { InProductFeedback } from '@iamexperiences/inproductfeedback';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { useAuth } from '@iamexperiences/feature-auth';

export interface InProductFeedbackDialogProps {
  feedbackItemId?: string;
  onDismiss?: VoidFunction;
}

export const InProductFeedbackDialog: React.FC<InProductFeedbackDialogProps> = ({ feedbackItemId, onDismiss }) => {
  const { auth } = useAuth();
  const [tInProductFeedback] = useLocalization('InProductFeedback');
  const [tInProductFeedbackMyAccount] = useLocalization('InProductFeedbackMyAccount');
  const getToken = useCallback(
    async (scope: string) => {
      return await auth.acquireToken({ scopes: [scope] });
    },
    [auth],
  );

  const ondismissInProductFeedback = useCallback(() => {
    onDismiss?.();
  }, [onDismiss]);

  const inProductFeedbackLocalizedSettings = getInProductFeedbackLocalizedSettings(tInProductFeedback);
  inProductFeedbackLocalizedSettings.appContext.feedback.tenantId = auth.user?.tenantId ?? '';
  inProductFeedbackLocalizedSettings.appContext.feedback.userId = auth.user?.objectId ?? '';
  inProductFeedbackLocalizedSettings.appContext.feedback.email = auth.user?.username ?? '';
  inProductFeedbackLocalizedSettings.appContext.feedback.getToken = getToken;
  inProductFeedbackLocalizedSettings.appContext.onDismiss = ondismissInProductFeedback;

  const surveyName = (feedbackItemId ?? window.location.pathname).replace(/\//g, '');

  const inProductFeedbackMyAccountFeedbackItemSettings = getInProductFeedbackMyAccountFeedbackItemSettings(
    tInProductFeedbackMyAccount,
    surveyName,
  );

  inProductFeedbackLocalizedSettings.appContext.feedback.surveyId = inProductFeedbackMyAccountFeedbackItemSettings.surveyId;
  inProductFeedbackLocalizedSettings.appContext.feedback.surveyName = surveyName;
  inProductFeedbackLocalizedSettings.appContext.originatorType = inProductFeedbackMyAccountFeedbackItemSettings.originatorType;
  inProductFeedbackLocalizedSettings.appContext.ces = inProductFeedbackMyAccountFeedbackItemSettings.ces;
  inProductFeedbackLocalizedSettings.appContext.cva = inProductFeedbackMyAccountFeedbackItemSettings.cva;
  inProductFeedbackLocalizedSettings.appContext.csat = inProductFeedbackMyAccountFeedbackItemSettings.csat;

  return (
    <InProductFeedback
      context={inProductFeedbackLocalizedSettings.context}
      appContext={inProductFeedbackLocalizedSettings.appContext}
    />
  );
};
